<script lang="ts">
    import PreviewCard from '../../../../custom/PreviewCard/PreviewCard.svelte'
    import { list } from '../../../../stores'
</script>

{#if $list}
  {#each $list as publication}
    <PreviewCard {publication} />
  {/each}
{/if}